import ProfilePageContent from '../components/profileapp/ProfileApp';

const ProfileAppPage = () => {
  return <ProfilePageContent />;
};

export default ProfileAppPage;